import styled from 'styled-components'

import { TitleSection as Section } from '@organisms/TitleSection'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const TitleSection = styled(Section)``

export const Link = styled(LinkBase)`
    text-decoration: none;
`
